import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core"

import {
  RequiredUserPermissions,
  RequiredUserRoles,
  UserStore
} from "../../@core/stores/user.store"


@Directive({
  selector: '[hasAuth]',
})
export class IsAuthDirective implements OnChanges {

  @Input('requiredRoles')
  reqRoles: RequiredUserRoles | null = null;

  @Input('requiredPermissions')
  reqPerms: RequiredUserPermissions | null = null;

  @Input('combinationMode')
  combine: 'both' | 'either' = 'both';

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly userStore: UserStore,
  ) { }

  ngOnChanges(): void {
    this.updateView();
  }


  private updateView(): void {
    this.viewContainer.clear();

    if (this.isAuthorized()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }


  private isAuthorized(): boolean {
    if (!this.reqPerms?.permissions.length && !this.reqRoles?.roles?.length) {
      return true;
    }

    return this.userStore.isAuthorizedFor(this.reqRoles, this.reqPerms, this.combine);
  }
}

